export default function scrollUp ($buttons) {
	// let $document = $(document);
	let $window = $(window);
	let $htmlBody = $('html, body');
	let timeout = null;
	let checkScrollPos = ($btn) => {
		$btn.toggleClass('is-visible', $window.scrollTop() >= $window.height());
	};

	$buttons.each((i, btn) => {
		let $btn = $(btn);

		checkScrollPos($btn);

		$btn.on('click', () => {
			$htmlBody.stop().animate({scrollTop: 0}, $btn.data('speed') || 750);
			return false;
		});

		$window
			.on('wheel', () => {
				$htmlBody.stop();
			})
			.on('scroll', () => {
				clearTimeout(timeout);

				timeout = setTimeout(function () {
					checkScrollPos($btn);
				}, 150);
			})
			.trigger('scroll');
	});
}



// WEBPACK FOOTER //
// ./_HTML/src/js/_modules/scrollUp.js